import { render, staticRenderFns } from "./ReviewQuoteOrderDetails.vue?vue&type=template&id=267bd95e&scoped=true&"
import script from "./ReviewQuoteOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ReviewQuoteOrderDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267bd95e",
  null
  
)

export default component.exports